var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCommunity = function SvgCommunity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106,
    height: 76,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FEECF0",
    strokeWidth: 20,
    d: "M104.256 11 4 22l90.256 29L4 66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F1416C",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M49 33.883h13.37M73.5 29.45v24.5l-6.673-6.697H46.783a8.89 8.89 0 0 1-8.913-9.006V29.45a8.913 8.913 0 0 1 8.913-8.913h17.804A8.914 8.914 0 0 1 73.5 29.45Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F1416C",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M60.13 18.297v2.333H46.783a8.913 8.913 0 0 0-8.913 8.913v6.674h-6.697l-6.673 6.58v-24.5a8.913 8.913 0 0 1 8.913-8.914h17.92a8.913 8.913 0 0 1 8.797 8.914Z"
  })));
};
export default SvgCommunity;